import React from "react";
import "../../styles/ClaimActivity.scss";
import Card from "../card/Card";
import AddNotesModal from "../add-notes-modal/AddNotesModal";
import { createNote } from "../../services/ClaimDetailsPage.Service";
import Loader from "../loader/Loader";

const ClaimActivity = (props) => {
    const { activityData } = props;
    const [tpaData, setTpaData] = React.useState(null);
    const [displayActivityData, setDisplayActivityData] = React.useState(false);
    const [isModalShow, setModalShow] = React.useState(false);
    const [notesData, setNotesData] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(false);
    const [subTitle,setSubTitle] = React.useState(null);

    React.useEffect(() => {
        const localStorageData = JSON.parse(localStorage.getItem("tpa_data"));
        setTpaData(localStorageData);
        if (localStorageData?.show_activity_panel) {
            setDisplayActivityData(true);
            setNotesData(activityData);
        }
        if(localStorageData?.admin_Type?.toLowerCase() === 'scs') {
            setSubTitle('Add Notes');
        }
    }, [activityData]);

    const submitNotes = async (notes) => {
        setIsLoading(true);
        const claimData = await JSON.parse(localStorage.getItem("claim_number"));
        const res = await createNote(claimData?.claimNumber , notes).then((data) => {return data;});
        setNotesData(res?.data?.notes);
        setIsLoading(false);
    }

    React.useEffect(() => {
        if(isModalShow) {
            document.body.style.overflow = "hidden";
            return;
        }
        document.body.style.overflow = 'auto';
        return;
    },[isModalShow]);


    const displayData = () => {
        if (notesData) {
            var data = notesData.sort((a, b) => new Date(b.createDate) - new Date(a.createDate));
            return (
                data.map((item, i) => {
                    var today = new Date(item?.createDate);
                    const options = { year: 'numeric', month: 'short', day: '2-digit', hour12: true, hour: '2-digit', minute: '2-digit' };
                    today = today.toLocaleDateString('en-US', options);
                    return (
                        <div className="claim-activity-notes-container" key={i}>
                            <div className="claim-activity-notes-time">
                                {today}
                            </div>
                            <div className="claim-activity-notes-text">
                                {item?.text ?? ""}
                            </div>
                            <div className="claim-activity-notes-time mb-9">
                                by {tpaData.admin_Type === 'SEA' ? item?.author?.name ?? "" : item?.author?.id ?? ""}
                            </div>
                        </div>
                    )
                }
                )
            )
        }
    }
    return (
        <React.Fragment>
            {isLoading ? <Loader /> : ""}
            {displayActivityData &&
                <div className="card-container">
                    <Card cardTitle="Claim Activity" cardIcon="fas fa-bars" sabTitle={subTitle} setModalShow={setModalShow} >
                        <div className="pl-31">
                            {displayData()}
                        </div>
                    </Card>
                </div>
            }
            {isModalShow && (
                <AddNotesModal setModalShow={setModalShow} submitNotes={submitNotes} />
            )}
        </React.Fragment>
    )
};

export default ClaimActivity;